import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {FormField} from 'shells/form/form-field';
import {FormattedNumberField} from 'shells/formatted-number-field/formatted-number-field';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {GetMarkets_markets_edges_node as Market} from 'nutshell-graphql-types';

type Props = {
    market: Market;
    price: number;
    isAvailable: boolean;
    onChange: (price: number, isAvailable: boolean) => void;
};

export function ProductMarketField(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <FormField
                innerId={`${props.market.id}-price`}
                label={`${props.market.name} ${
                    props.market.currencySymbol ? `(${props.market.currencySymbol})` : ''
                }`}
                noMargin={true}
            >
                <FormattedNumberField
                    // @ts-expect-error
                    id={`${props.market.id}-price`}
                    value={props.price}
                    formatType='float'
                    disabled={!props.isAvailable}
                    onChange={(value) => {
                        if (!value) {
                            props.onChange(0, props.isAvailable);
                        } else {
                            props.onChange(value, props.isAvailable);
                        }
                    }}
                />
            </FormField>
            <StackLegacy isHorizontal={true} spacing={8}>
                <FormField innerId={`${props.market.id}-availability`}>
                    <Checkbox
                        // @ts-expect-error
                        id={`${props.market.id}-availability`}
                        label='Unavailable in market'
                        checked={!props.isAvailable}
                        onChange={(isUnavailable) => props.onChange(props.price, !isUnavailable)}
                    />
                </FormField>
            </StackLegacy>
        </StackLegacy>
    );
}
